import { GameAssetType } from '../../game-types';
import { PileType } from 'src/games/phasersolitaire/logic/logic-types';
import { GameServices } from '../../game-services';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export abstract class PileViewModel {
  public get backgroundAsset() {
    const assetName = () => {
      if (this.pileType === PileType.Deck) {
        return GameAssetType.PileDeck;
      }
      return this.pileType === PileType.Foundation
        ? GameAssetType.PileFoundation
        : GameAssetType.Pile;
    };
    return this.gameServices.assetCatalogueService.getAsset(assetName());
  }
  public get currentPileType() {
    return this.pileType;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }

  protected readonly gameServices: GameServices;
  private readonly pileType: PileType;

  constructor(gameServices: GameServices, pileType: PileType) {
    this.gameServices = gameServices;
    this.pileType = pileType;
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    totalWidth: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }
}
